export default "__VITE_ASSET__7ef23ae6__"